var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-auto"},[(_vm.isForm)?_c('ForgotPasswordForm',{on:{"success":function($event){_vm.isForm = false}}}):_c('ForgotPasswordSuccess')],1)}
var staticRenderFns = []

export { render, staticRenderFns }